
import { Options, Vue } from 'vue-class-component';
import { CourseProduct, Product } from "@/data/products";
import ProductCard from "@/components/ProductCard.vue";
import StepsNavEntry from "@/components/checkout/StepsNavEntry.vue";
import StepUserGuest, { StepUserGuestData } from "@/components/checkout/steps/StepUserGuest.vue";
import StepVoucher, { StepVoucherData } from "@/components/checkout/steps/StepVoucher.vue";
import StepPayment from "@/components/checkout/steps/StepPayment.vue";
import GlobalStore from "@/utils/global-store";
import {PropType} from "vue";

type VoucherMode = null | 'redeem' | 'order';

type StepState = 'valid' | 'invalid' | 'error' | null;
type StepStates = StepState[];

interface StepsData {
    userGuest: StepUserGuestData | null,
    voucher: StepVoucherData | null,
}

@Options({
    props: {
        product: {
            type: Object as PropType<Product|CourseProduct>,
            required: true,
        },
        regionName: {
            type: String,
            required: false,
            default: null,
        },
        /*region: {
            type: Boolean,
            required: true,
        }*/
    },
    components: {
        ProductCard,
        StepPayment,
        StepVoucher,
        StepUserGuest,
        StepsNavEntry,
    },
    emits: {
        success: (value: any) => value === null || typeof value === 'string' || Array.isArray(value),
    },
})
export default class StepsCheckout extends Vue {
    product!: Product|CourseProduct
    regionName!: string|null

    currentStep = 0

    stepsState: StepStates = [
        null, // step 0 userGuest
        null, // step 1 voucher
        null, // step 2
    ]

    stepsData: StepsData = {
        userGuest: null,
        voucher: null,
    }


    switchToStep(stepIndex: number) {
        if( stepIndex <= (this.highestValidStep + 1) ) {
            this.currentStep = stepIndex;
        }
    }


    get highestValidStep() {
        return this.stepsState.findIndex(val => val !== 'valid') - 1;
    }

    goToNextStep() {
        if( this.highestValidStep >= this.currentStep ) {
            ++this.currentStep;
        }
    }

    onPaymentSuccess(message?: string|string[]) {
        // reset remembered voucher code
        GlobalStore.set('voucherCode', null);

        this.$emit('success', message);
    }


    mounted() {
        this.$nextTick(() => {
            if( this.stepsState[0] === 'valid' && this.currentStep === 0 ) {
                this.currentStep = 1;
            }
        });
    }
}
